<template>
	
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.account" placeholder="手机号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getwhiteList">查询</el-button>
				</el-form-item>
				<!--<el-form-item>
					<el-button type="primary" @click="handleAdd">导出</el-button>
				</el-form-item>-->
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="whites" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<!--<el-table-column type="selection" width="50">
			</el-table-column>-->
			<el-table-column type="index" >
			</el-table-column>			
			<el-table-column prop="user_name" label="用户昵称"  >
			</el-table-column>
			<el-table-column prop="phone_number" label="手机号"  >
			</el-table-column>
			<el-table-column prop='creatTime' label="创建时间"   >
			</el-table-column>
			<el-table-column label="操作" width="">
				<template slot-scope="scope">
					<el-button size="small" @click="delewhite(scope.$index, scope.row)">删除白名单</el-button>
					<!--<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>-->
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除{{addFormVisible}}</el-button>-->
			<el-pagination layout="prev, pager, next,jumper"  @current-change="handleCurrentChange"  :page-size="size" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
	</section>
</template>

<script>
	import util from '../common/js/util'
	//import NProgress from 'nprogress'
	import { whiteList, addWhite, deleteWhite,} from '../api/api';
	export default{
		data(){
			return{
				filters: {
					account: ''
				},
				total: 0,
				page: 1,
				size:10,
				listLoading:false,
				whites:[],
			}
		},
		methods:{
			selsChange: function (sels) {
				this.sels = sels;
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getwhiteList();
			},
			getwhiteList:function(){
				var that=this
				let para = {
					phoneNumber:this.filters.account.trim(),
					organ_sysno:this.GLOBAL.organ_sysno,
					pageNo:this.page,
					pageSize:this.size,
				};
				this.listLoading = true;
				whiteList(para).then((res) => {
					this.listLoading = false;
					this.total = res.data.data.rowcount;
					that.whites=res.data.data.list
					console.log(that.whites)
				})
			},
			delewhite(a,b){
				console.log(b)
				let para = {
					white_sysno:b.white_sysno,
					openid:b.openid,
					organ_sysno:this.GLOBAL.organ_sysno
				};
				deleteWhite(para).then((res)=>{
					console.log(res)
					this.getwhiteList();
				})
			},
		},
		mounted() {
			this.getwhiteList();
		}
	}
</script>

<style slot-scope>
</style>


// WEBPACK FOOTER //
// src/components/whiteList.vue